import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeader({ title, subtitle, linkTo, linkLabel }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-6 md:mb-8">
      <div>
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-50">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
        )}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-300 whitespace-nowrap"
        >
          {linkLabel || '查看全部'}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      )}
    </div>
  );
}